import { useMutation } from "react-query";
import { toast } from "react-hot-toast";
import PDFRedirecionamentoEmailUnico from "../../modules/groupPay/assets/RedirecionamentoEmailUnico.pdf";
import PDFRedirecionamentoEmailAdministradora from "../../modules/groupPay/assets/AcessoEmailAdministradora.pdf";

export enum TipoGuia {
  REDIRECIONAMENTO_EMAIL_UNICO = "REDIRECIONAMENTO_EMAIL_UNICO",
  REDIRECIONAMENTO_EMAIL_ADMINISTRADORA = "REDIRECIONAMENTO_EMAIL_ADMINISTRADORA",
}

type GuiaRequest = {
  tipoGuia: TipoGuia;
};

const guiasMap = {
  [TipoGuia.REDIRECIONAMENTO_EMAIL_UNICO]: PDFRedirecionamentoEmailUnico,
  [TipoGuia.REDIRECIONAMENTO_EMAIL_ADMINISTRADORA]: PDFRedirecionamentoEmailAdministradora,
};

const getGuiaUrl = async (request: GuiaRequest): Promise<{ url: string }> => {
  const pdfSrc = guiasMap[request.tipoGuia];

  if (!pdfSrc) {
    throw new Error("Guia não encontrado");
  }

  return { url: pdfSrc };
};

export const useGetGuiaRedirecionamento = () => {
  return useMutation(getGuiaUrl, {
    onSuccess: (data) => {
      if (data.url) {
        window.open(data.url, "_blank", "noopener,noreferrer");
      }
    },
    onError: () => {
      toast.error("Não foi possível carregar o guia. Tente novamente.");
    },
  });
};
